(() => {
  const galleries = document.querySelectorAll('[data-product-gallery]');
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const section = gallery.closest('[data-product-section]');
    const panels = Array.from(gallery.querySelectorAll('[data-media-panel]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-media-target]'));
    const thumbRail = gallery.querySelector('[data-product-thumbnails]');
    const currentCounter = gallery.querySelector('[data-gallery-current]');
    const lightbox = section?.querySelector('[data-product-lightbox]');
    const zoomImage = lightbox?.querySelector('[data-lightbox-image]');
    const lightboxCounter = lightbox?.querySelector('[data-lightbox-counter]');
    const imagePanelIndexes = panels
      .map((panel, index) => panel.dataset.mediaType === 'image' ? index : -1)
      .filter((index) => index >= 0);

    let activeIndex = Math.max(0, panels.findIndex((panel) => panel.classList.contains('is-active')));
    let lightboxPanelIndex = activeIndex;
    let touchStartX = 0;
    let lastFocused = null;

    const clampIndex = (index) => {
      if (!panels.length) return 0;
      return (index + panels.length) % panels.length;
    };

    const pauseInactiveMedia = () => {
      panels.forEach((panel, index) => {
        if (index === activeIndex) return;
        panel.querySelectorAll('video').forEach((video) => video.pause());
      });
    };

    const activate = (index, options = {}) => {
      if (!panels.length) return;
      activeIndex = clampIndex(index);

      panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === activeIndex;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', String(isActive));
        thumb.tabIndex = isActive ? 0 : -1;
      });

      currentCounter && (currentCounter.textContent = String(activeIndex + 1));
      pauseInactiveMedia();

      const activeThumb = thumbs[activeIndex];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: options.instant ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        if (options.focusThumb) activeThumb.focus({ preventScroll: true });
      }
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => activate(index));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') activate(0, { focusThumb: true });
        else if (event.key === 'End') activate(panels.length - 1, { focusThumb: true });
        else activate(index + (event.key === 'ArrowRight' ? 1 : -1), { focusThumb: true });
      });
    });

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => activate(activeIndex - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => activate(activeIndex + 1));

    gallery.querySelectorAll('[data-thumb-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!thumbRail) return;
        const direction = Number(button.dataset.thumbScroll || 1);
        thumbRail.scrollBy({ left: direction * Math.max(260, thumbRail.clientWidth * 0.72), behavior: 'smooth' });
      });
    });

    thumbRail?.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      event.preventDefault();
      thumbRail.scrollLeft += event.deltaY;
    }, { passive: false });

    const stage = gallery.querySelector('[data-product-stage]');
    stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        activate(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        activate(activeIndex + 1);
      }
    });

    stage?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });

    stage?.addEventListener('touchend', (event) => {
      const endX = event.changedTouches[0]?.clientX || 0;
      const distance = endX - touchStartX;
      if (Math.abs(distance) < 45) return;
      activate(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    const imagePositionInLightbox = (panelIndex) => imagePanelIndexes.indexOf(panelIndex);

    const setLightboxImage = (panelIndex) => {
      if (!lightbox || !zoomImage || !imagePanelIndexes.length) return;
      const normalizedPosition = (imagePositionInLightbox(panelIndex) + imagePanelIndexes.length) % imagePanelIndexes.length;
      lightboxPanelIndex = imagePanelIndexes[normalizedPosition];
      const panel = panels[lightboxPanelIndex];
      zoomImage.src = panel.dataset.zoomSrc || '';
      zoomImage.alt = panel.dataset.zoomAlt || '';
      if (lightboxCounter) lightboxCounter.textContent = `${normalizedPosition + 1} / ${imagePanelIndexes.length}`;
    };

    const openLightbox = (panelIndex) => {
      if (!lightbox || !imagePanelIndexes.includes(panelIndex)) return;
      lastFocused = document.activeElement;
      setLightboxImage(panelIndex);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-lightbox-open');
      lightbox.querySelector('[data-lightbox-close]:not(.product-lightbox__backdrop)')?.focus();
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-lightbox-open');
      lastFocused?.focus?.();
    };

    panels.forEach((panel, index) => {
      panel.querySelector('[data-product-zoom-trigger]')?.addEventListener('click', () => openLightbox(index));
    });

    lightbox?.querySelectorAll('[data-lightbox-close]').forEach((button) => button.addEventListener('click', closeLightbox));
    lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => {
      const current = imagePositionInLightbox(lightboxPanelIndex);
      setLightboxImage(imagePanelIndexes[(current - 1 + imagePanelIndexes.length) % imagePanelIndexes.length]);
    });
    lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => {
      const current = imagePositionInLightbox(lightboxPanelIndex);
      setLightboxImage(imagePanelIndexes[(current + 1) % imagePanelIndexes.length]);
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') lightbox.querySelector('[data-lightbox-prev]')?.click();
      if (event.key === 'ArrowRight') lightbox.querySelector('[data-lightbox-next]')?.click();
    });

    const select = section?.querySelector('[data-product-select]');
    const price = section?.querySelector('[data-product-price]');
    const comparePrice = section?.querySelector('[data-product-compare-price]');
    const stock = section?.querySelector('[data-product-stock]');
    const addButton = section?.querySelector('[data-add-to-cart]');

    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      const mediaId = option.dataset.mediaId;

      if (price) price.textContent = option.dataset.price || '';
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
      }
      if (stock) {
        stock.classList.toggle('is-unavailable', !available);
        const stockText = stock.querySelector('[data-stock-text]');
        if (stockText) stockText.textContent = available ? 'In stock and ready to order' : 'Currently unavailable';
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
      if (mediaId) {
        const mediaIndex = panels.findIndex((panel) => panel.dataset.mediaPanel === mediaId);
        if (mediaIndex >= 0) activate(mediaIndex);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });

    section?.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      const input = section.querySelector('.quantity-selector__input');
      if (!input) return;
      input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    section?.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      const input = section.querySelector('.quantity-selector__input');
      if (!input) return;
      input.value = String(Number(input.value || 1) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    activate(activeIndex, { instant: true });
  });
})();
